import {
	faArrowUpWideShort,
	faCheck,
	faClose,
	faEllipsisVertical,
	faFileExport,
	faFilter,
	faRefresh,
	faSearch,
} from "@fortawesome/free-solid-svg-icons";
import * as moment from "moment";
import { useEffect, useRef, useState } from "react";
import { downloadExcel } from "react-export-table-to-excel";
import { useIntl } from "react-intl";
import { connect, useDispatch } from "react-redux";
import { showPopup } from "../../store/thunks/popups";
import { approveOrRejectRegisteredUser, fetchRegisteredUsers } from "../../store/thunks/registrations";
import {
	ANCHAL,
	POPUPS,
	REGISTERED_SORT_OPTONS,
	SORT_BY,
	TOAST_STATE_DANGER,
	USER_STATUS,
} from "../../utils/constants";
import { sortData } from "../../utils/utils";
import Button from "../DesignSystem/Button/Button";
import Card from "../DesignSystem/Card/Card";
import CustomInput from "../DesignSystem/CustomInput/CustomInput";
import PopoverContent from "../DesignSystem/Popover/PopoverContent";
import PopoverHandler from "../DesignSystem/Popover/PopoverHandler";
import PopoverItem from "../DesignSystem/Popover/PopoverItem";
import Sidemenu from "../DesignSystem/Sidemenu/Sidemenu";
import Table from "../DesignSystem/Table/Table";
import TableItem from "../DesignSystem/Table/TableItem";
import { Tab } from "../DesignSystem/Tabs/Tab";
import { Tabs } from "../DesignSystem/Tabs/Tabs";
import Header from "../Header/Header";
import ActiveUsers from "./ActiveUsers";
import "./Registrations.scss";
import { VerticalDivider } from "../DesignSystem/VerticalDivider/VerticalDivider";
import RejectedUsers from "./RejectedUsers";
import { getKnowledgeStatusByNumber } from "./RegistrationUtils";
import { showToast } from "../../store/thunks/toasts";
import JSZip from "jszip";

let actualUsers = [];

export default connect(
	(state) => ({
		...state.registrations,
	}),
	{ fetchRegisteredUsers, approveOrRejectRegisteredUser }
)(({ fetchingRegisteredUsers, fetchingRegisteredUsersComplete, activeUsers, rejectedUsers, registeredUsers }) => {
	const dispatch = useDispatch();
	const { formatMessage } = useIntl();

	const [anchalMapping, setAnchalMapping] = useState([]);
	const [usersList, setUsersList] = useState(registeredUsers);
	const [activeId, setActiveId] = useState("active");

	const [search, setSearch] = useState("");
	const [isFilterApplied, setIsFilterApplied] = useState(false);
	const searchInput = useRef();

	const [selectedUsers, setSelectedUsers] = useState([]);
	const [didSelectMultipleUsers, setDidSelectMultipleUsers] = useState(false);

	useEffect(() => {
		if (!registeredUsers.length) {
			dispatch(fetchRegisteredUsers());
		}
	}, [registeredUsers]);

	useEffect(() => {
		if (activeId === "active") {
			setUsersList(activeUsers);
		} else {
			setUsersList(rejectedUsers);
		}
		actualUsers = registeredUsers;

		const mapping = [];
		ANCHAL.forEach((anch) => {
			const anchalBasedFilter = registeredUsers.filter((user) => {
				return user.region === anch;
			});

			mapping.push({
				anchal: anch,
				count: anchalBasedFilter.length,
			});
		});

		setAnchalMapping(mapping);
	}, [activeUsers, rejectedUsers, registeredUsers]);

	const getUsersCountByStatus = (status) => {
		let statusCount = 0;

		statusCount = actualUsers.filter((user) => {
			return user.approvalStatus === status;
		}).length;

		return statusCount;
	};

	const handleSearchInputChange = () => {
		let searchString = searchInput.current.value;
		setSearch(searchString);

		if (!searchString) {
			setUsersList(actualUsers);
			return;
		}

		searchString = searchString.trim();
		let list = activeId === "active" ? activeUsers : rejectedUsers;

		const searchRegExp = new RegExp(`${searchString}`, "i");
		list = list.filter((user) => {
			return (
				user.firstName.match(searchRegExp) ||
				(user.city ? user.city.match(searchRegExp) : false) ||
				(user.state ? user.state.match(searchRegExp) : false)
			);
		});

		setUsersList(list);
	};

	const onClickExportToExcel = () => {
		let header = [
			"First Name",
			"Last Name",
			"Fathers Name",
			"Mobile Number",
			"Date of birth",
			"Gender",
			"Anchal",
			"Knowledge Status",
			"City",
			"State",
			"Address",
			"Pincode",
			"Education",
			"Occupation",
			"Medical Conditions",
		];

		const excelData = [];
		usersList.forEach((user) => {
			excelData.push({
				firstName: user.firstName,
				lastName: user.lastName,
				fathersName: user.fathersName,
				mobileNumber: user.mobileNumber,
				dateOfBirth: moment.unix(user.dob).format("DD/MM/YYYY"),
				gender: user.gender,
				anchal: user.region,
				knowledgeStatus: getKnowledgeStatusByNumber(user.knowledgeStatus, formatMessage).join(", "),
				city: user.city,
				state: user.state,
				address: user.address,
				pincode: user.pinCode,
				education: user.education,
				occupation: user.occupation,
				medicalConditions: user.medicalConditions,
			});
		});

		downloadExcel({
			fileName: "RegisteredUsersList",
			sheet: "Sheet 1",
			tablePayload: {
				header,
				body: excelData,
			},
		});
	};

	const downloadImages = async () => {
		if (usersList.length) {
			let imageStringsAndIds = [];
			usersList.forEach((user) => {
				imageStringsAndIds.push({
					image: user.photo,
					regNumber: user.regNumber,
					firstName: user.firstName,
					lastName: user.lastName,
				});
			});

			const zip = new JSZip();
			imageStringsAndIds.forEach((data, index) => {
				const base64Data = data.image.split(",")[1];
				const fileName = `${data.firstName}_${data.lastName}_${data.regNumber}.jpg`;

				zip.file(fileName, base64Data, { base64: true });
			});

			const zipBlob = await zip.generateAsync({ type: "blob" });

			// Trigger download
			const link = document.createElement("a");
			link.href = URL.createObjectURL(zipBlob);
			link.download = "images.zip";
			document.body.appendChild(link);
			link.click();
		}
	};

	const onClickRefresh = async () => {
		await dispatch(fetchRegisteredUsers());
	};

	const onClickFilterItem = (filterItem) => {
		onClickClearFilter();
		const filteredList = actualUsers.filter((user) => {
			return user.approvalStatus === filterItem;
		});

		setUsersList(filteredList);
		setIsFilterApplied(true);
	};

	const onClickClearFilter = () => {
		if (activeId === "active") {
			setUsersList(activeUsers);
		} else {
			setUsersList(rejectedUsers);
		}
		setIsFilterApplied(false);
	};

	const onClickSortItem = (sortOption) => {
		onClickClearFilter();
		let sortedList = [];

		if (activeId === "active") {
			actualUsers = JSON.parse(JSON.stringify(activeUsers));
		} else {
			actualUsers = JSON.parse(JSON.stringify(rejectedUsers));
		}

		switch (sortOption) {
			case REGISTERED_SORT_OPTONS.NAME_ASCENDING:
				sortedList = sortData(actualUsers, SORT_BY.ASCENDING, "firstName");
				break;
			case REGISTERED_SORT_OPTONS.NAME_DESCENDING:
				sortedList = sortData(actualUsers, SORT_BY.DESCENDING, "firstName");
				break;
			case REGISTERED_SORT_OPTONS.STATUS_ASCENDING:
				sortedList = sortData(actualUsers, SORT_BY.ASCENDING, "approvalStatus");
				break;
			case REGISTERED_SORT_OPTONS.STATUS_DESCENDING:
				sortedList = sortData(actualUsers, SORT_BY.DESCENDING, "approvalStatus");
				break;
			default:
				sortedList = actualUsers;
		}

		setUsersList(sortedList);
	};

	const onClickHeader = (region) => {
		let anchalFilteredData = [];
		if (activeId === "active") {
			anchalFilteredData = activeUsers.filter((user) => {
				return region === user.region;
			});
		} else {
			anchalFilteredData = rejectedUsers.filter((user) => {
				return region === user.region;
			});
		}

		setUsersList(anchalFilteredData);
		setIsFilterApplied(true);
	};

	const onClickViewUserDetails = async (user) => {
		await dispatch(showPopup(POPUPS.USER_DETAILS_POPUP, { ...user }));
	};

	const onClickEditUser = async (user) => {
		await dispatch(showPopup(POPUPS.EDIT_USER_POPUP, { ...user }));
	};

	const handleMultiSelectRows = (e) => {
		if (e.target.checked) {
			if (!selectedUsers.includes(e.target.id)) {
				selectedUsers.push(e.target.id);
			}
		} else {
			if (selectedUsers.includes(e.target.id)) {
				const index = selectedUsers.indexOf(e.target.id);
				if (index > -1) {
					selectedUsers.splice(index, 1);
				}
			}
		}
		setSelectedUsers(selectedUsers);

		if (selectedUsers.length) {
			setDidSelectMultipleUsers(true);
		} else {
			setDidSelectMultipleUsers(false);
		}
	};

	const onClickApproveUser = async (user) => {
		let payload = {};
		if (selectedUsers.length) {
			let selectedUsersForApproval = {
				updates: [],
			};
			selectedUsers.forEach((item) => {
				selectedUsersForApproval.updates.push({
					id: item,
					approvalStatus: USER_STATUS.APPROVED,
				});
			});
			payload = selectedUsersForApproval;
		} else {
			payload = {
				updates: [
					{
						id: user.id,
						approvalStatus: USER_STATUS.APPROVED,
					},
				],
			};
		}

		const approveUserResponse = await dispatch(approveOrRejectRegisteredUser(payload));
		if (approveUserResponse) {
			dispatch(
				showToast({
					message: "registration.approval.success",
				})
			);
			await dispatch(fetchRegisteredUsers());
		} else {
			dispatch(
				showToast({
					message: "registration.approval.error",
					type: TOAST_STATE_DANGER,
				})
			);
		}
	};

	return (
		<div className="dashboard-container">
			<Header />
			<div className="wrapper flex direction-row justify-content-between align-items-start">
				<Sidemenu />
				<div className="dashboard-content flex direction-col justify-content-start align-items-start">
					<div className="text text-header--7 text-left">
						{formatMessage({ id: "registration.pageTitle" })}
					</div>

					<div className="mt-24" style={{ width: "100%" }}>
						<div className="row">
							<div className="col-lg-4">
								<Card>
									<div className="text text-body-2 text-bold text-left">
										{formatMessage({ id: "registration.count" })}
									</div>
									<div className="row mt-16">
										<div className="col-6 flex direction-col">
											<div className="text text-header--2 text-success">
												{getUsersCountByStatus(USER_STATUS.APPROVED)}
											</div>
											<div className="text text-body--4">
												{formatMessage({ id: "registration.card.text.approvedUsers" })}
											</div>
										</div>
										<div className="col-6 flex direction-col">
											<div className="text text-header--2 text-yellow">
												{getUsersCountByStatus(USER_STATUS.PENDING)}
											</div>
											<div className="text text-body--4">
												{formatMessage({ id: "registration.card.text.pendingApproval" })}
											</div>
										</div>
									</div>
								</Card>
							</div>
						</div>
					</div>

					<div className="mt-24" style={{ width: "100%" }}>
						<div className="text text-body-3 text-bold text-left">
							{formatMessage({ id: "registration.list.anchalMapping" })}
						</div>
						<div className="mt-16">
							<Table headers={ANCHAL} shouldHighlight={true} onClick={onClickHeader} />
							<div className="table-items flex direction-row align-items-center justify-content-between">
								{anchalMapping.map((data) => {
									return <TableItem data={data.count} />;
								})}
							</div>
						</div>
					</div>

					<div className="text text-body-4 text-bold text-left mt-24">
						{formatMessage({ id: "registration.list.subtitle" })}
					</div>
					<div className="page-options mt-8" style={{ width: "100%" }}>
						<div className="row flex direction-row justify-content-between">
							<div className="col flex direction-row align-items-end">
								<CustomInput
									id="userSearchBar"
									icon={faSearch}
									isMandatory={false}
									placeholder="registration.userSearch.placeholder"
									ref={searchInput}
									onChange={handleSearchInputChange}
									value={search}
								/>
							</div>

							<div className="col flex direction-row align-items-center justify-content-end">
								<Button
									className="button-tertiary table-action-button ml-8"
									label="registration.actions.refresh"
									icon={faRefresh}
									onClick={onClickRefresh}
								/>

								{activeId === "active" && (
									<PopoverHandler
										label={formatMessage({ id: "registration.actions.filter" })}
										icon={faFilter}
									>
										<PopoverContent>
											<PopoverItem
												className={`${isFilterApplied ? "button-active" : ""}`}
												label={formatMessage({ id: "registraion.filterOptions.approved" })}
												onClick={() => onClickFilterItem(USER_STATUS.APPROVED)}
											/>
											<PopoverItem
												className={`${isFilterApplied ? "button-active" : ""}`}
												label={formatMessage({ id: "registraion.filterOptions.rejected" })}
												onClick={() => onClickFilterItem(USER_STATUS.REJECTED)}
											/>
											<PopoverItem
												className={`${isFilterApplied ? "button-active" : ""}`}
												label={formatMessage({ id: "registraion.filterOptions.pending" })}
												onClick={() => onClickFilterItem(USER_STATUS.PENDING)}
											/>
										</PopoverContent>
									</PopoverHandler>
								)}

								<PopoverHandler
									label={formatMessage({ id: "registration.actions.sort" })}
									icon={faArrowUpWideShort}
								>
									<PopoverContent>
										<PopoverItem
											label={formatMessage({ id: "registraion.sortOptions.nameAscending" })}
											onClick={() => onClickSortItem(REGISTERED_SORT_OPTONS.NAME_ASCENDING)}
										/>
										<PopoverItem
											label={formatMessage({ id: "registraion.sortOptions.nameDescending" })}
											onClick={() => onClickSortItem(REGISTERED_SORT_OPTONS.NAME_DESCENDING)}
										/>
										<PopoverItem
											label={formatMessage({ id: "registraion.sortOptions.statusAscending" })}
											onClick={() => onClickSortItem(REGISTERED_SORT_OPTONS.STATUS_ASCENDING)}
										/>
										<PopoverItem
											label={formatMessage({ id: "registraion.sortOptions.statusDescending" })}
											onClick={() => onClickSortItem(REGISTERED_SORT_OPTONS.STATUS_DESCENDING)}
										/>
									</PopoverContent>
								</PopoverHandler>

								<PopoverHandler
									label={formatMessage({ id: "registration.actions.options" })}
									icon={faEllipsisVertical}
								>
									<PopoverContent>
										<PopoverItem
											label={formatMessage({ id: "registration.options.saveAsExcel" })}
											onClick={() => onClickExportToExcel()}
										/>
										<PopoverItem
											label={formatMessage({ id: "registration.options.downloadImages" })}
											onClick={downloadImages}
										/>
									</PopoverContent>
								</PopoverHandler>
							</div>
						</div>
					</div>

					<Tabs activeId={activeId} className="mt-24">
						<Tab
							id="active"
							label="Active Users"
							onClick={(id) => {
								onClickClearFilter();
								setSelectedUsers([]);
								setDidSelectMultipleUsers(false);
								setUsersList(activeUsers);
								setActiveId(id);
							}}
						></Tab>
						<Tab
							id="rejected"
							label="Rejected Users"
							onClick={(id) => {
								onClickClearFilter();
								setSelectedUsers([]);
								setDidSelectMultipleUsers(false);
								setUsersList(rejectedUsers);
								setActiveId(id);
							}}
						></Tab>
					</Tabs>

					<div
						className="flex direction-row align-items-center justify-content-between"
						style={{ width: "100%" }}
					>
						<div className="flex direction-row align-items-center justify-content-center">
							<div className="text text-body--3 text-disabled">
								{formatMessage({ id: "filtered.usersCount" }, { count: activeUsers.length })}
							</div>{" "}
							<VerticalDivider className="mt-16 mb-16"></VerticalDivider>
							<div className="text text-body--3 text-disabled">
								{formatMessage({ id: "registration.usersCount" }, { count: actualUsers.length })}
							</div>
						</div>

						<div className="flex direction-row align-items-center">
							{didSelectMultipleUsers ? (
								<Button
									className="button-tertiary button-success table-action-button ml-8"
									label="registration.actions.approveAllUsers"
									icon={faCheck}
									onClick={onClickApproveUser}
								/>
							) : (
								<></>
							)}
							{isFilterApplied ? (
								<div>
									<Button
										className="button-tertiary button-danger"
										label={"Clear Filter"}
										icon={faClose}
										onClick={onClickClearFilter}
									/>
								</div>
							) : (
								<></>
							)}
						</div>
					</div>
					{activeId === "active" ? (
						<ActiveUsers
							usersList={usersList}
							actualUsers={actualUsers}
							isFilterApplied={isFilterApplied}
							onClickClearFilter={onClickClearFilter}
							onClickViewUserDetails={onClickViewUserDetails}
							onClickEditUser={onClickEditUser}
							onClickApproveUser={onClickApproveUser}
							handleMultiSelectRows={handleMultiSelectRows}
						/>
					) : (
						<></>
					)}
					{activeId === "rejected" ? (
						<RejectedUsers
							usersList={usersList}
							onClickClearFilter={onClickClearFilter}
							onClickViewUserDetails={onClickViewUserDetails}
							onClickEditUser={onClickEditUser}
						/>
					) : (
						<></>
					)}
				</div>
			</div>
		</div>
	);
});
